import InfoTooltip from "newui/components/InfoTooltip";
import { FormLabel } from "../FormLabel";

interface LabelWithGuidelineProps {
	guideLine?: string;
	htmlFor?: string;
	label?: string;
	required?: boolean;
}

export const LabelWithGuideline = ({ guideLine, label, htmlFor, required }: LabelWithGuidelineProps) => {

	if (!label) {
		return null;
	}

	return <FormLabel
		htmlFor={htmlFor}
		label={label}
		required={required}
	>
		{guideLine && (
			<div className="inline-block">
				<InfoTooltip tooltipText={guideLine} />
			</div>
		)}
	</FormLabel>;
}